// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
import './assets/css/qi-mint.scss'
import './client/client.js'
import VConsole from "vconsole/dist/vconsole.min.js";
if (location.hostname.startsWith("test-")) {
  let vConsole = new VConsole();
}
// Vue.config.productionTip = false
import 'amfe-flexible'
// Vue.use(MintUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js